import { initializeDefaultNav } from './initialize/initialize_default_nav';

export const initialize = () => {
    const $defaultNav = $('.navigation--default');

    if ($defaultNav.length) {
        initializeDefaultNav($defaultNav);
    }
};
